import React from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { FPCardContent } from 'UI/components/atoms/FPCard';
import FPLinearProgress from 'UI/components/atoms/FPLinearProgress';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {Object} props.bulksValues
 * @param {Number} props.newCandidates
 * @param {Number} props.newJobOrders
 * @param {Object} props.sendoutsValues
 * @param {Object} props.sendoversValues
 */
const WeeklyStats = ({
  bulksValues,
  newCandidates,
  newJobOrders,
  sendoutsValues,
  sendoversValues
}) => {
  const history = useHistory();
  const theme = useTheme();
  const isSmallViewPort = useMediaQuery(theme.breakpoints.only('xs'));
  const classes = useStyles({ isSmallViewPort });

  const { primary, warning } = theme.palette;

  const linearProgressItems = [
    {
      title: strings.home.sections.weeklyStats.sendouts.title,
      backgroundColor: primary.FP100,
      color: primary.FP300,
      current: sendoutsValues.current,
      goal: sendoutsValues.goal
    },
    {
      title: strings.home.sections.weeklyStats.convertedSendovers.title,
      backgroundColor: warning.FP200,
      color: warning.light,
      current: sendoversValues.current,
      goal: sendoversValues.goal
    },
    {
      title: strings.home.sections.weeklyStats.bulks.title,
      backgroundColor: primary.FP100,
      color: primary.light,
      current: bulksValues.current,
      goal: bulksValues.goal
    }
  ];

  const cardItems = [
    {
      className: 'candidatesCard',
      redirectTo: `${EntityRoutes.Candidates}?orderBy=created_at&direction=desc`,
      title: strings.home.sections.weeklyStats.candidatesCard.title,
      value: newCandidates
    },
    {
      className: 'jobOrdersCard',
      redirectTo: `${EntityRoutes.JobOrders}?orderBy=created_at&direction=desc`,
      title: strings.home.sections.weeklyStats.jobOrdersCard.title,
      value: newJobOrders
    }
  ];

  const handleActionClick = action => () => history.push(action);
  return (
    <div className={classes.container}>
      <Grid container>
        {linearProgressItems.map(progressItem => (
          <Grid role="grid" key={progressItem.title} item xs={12} className={classes.content}>
            <Typography className={classes.title} variant="overline" noWrap>
              {progressItem.title}
            </Typography>

            <Grid className={classes.progressBarContainer}>
              <Grid item sm={10} xs={11} className={classes.progressBar}>
                <FPLinearProgress
                  backgroundColor={progressItem.backgroundColor}
                  color={progressItem.color}
                  value={
                    progressItem.current <= progressItem.goal
                      ? progressItem.current
                      : progressItem.goal
                  }
                  max={progressItem.goal}
                />
              </Grid>
              <Grid item sm={2} xs={1}>
                <Typography
                  className={classes.progressLabel}
                  variant="caption"
                  noWrap
                >{`${progressItem.current}/${progressItem.goal}`}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}

        <Grid role="group" item xs={12} className={classes.cardContainer}>
          {cardItems.map(cardItem => (
            <div key={cardItem.title} className={classes.cardContent}>
              <FPCardContent
                role="term"
                className={classes[cardItem.className]}
                onClick={handleActionClick(cardItem.redirectTo)}
              >
                <div className={classes.card}>
                  <Typography noWrap variant="overline" className={classes.titleCard}>
                    {cardItem.title}
                  </Typography>
                </div>

                <div className={classes.card}>
                  <Typography variant="h5" noWrap>
                    {cardItem.value}
                  </Typography>
                </div>
              </FPCardContent>
            </div>
          ))}
        </Grid>
      </Grid>
    </div>
  );
};

const initialState = {
  current: 0,
  goal: 0
};

WeeklyStats.defaultProps = {
  bulksValues: { ...initialState },
  newCandidates: 0,
  newJobOrders: 0,
  sendoutsValues: { ...initialState },
  sendoversValues: { ...initialState }
};

export default WeeklyStats;
